const CustomProductRecommendations = class extends HTMLElement {
  constructor() {
    super();
    this.init();
  }
  navigating = false;

  init() {
    const url = this.getAttribute("data-url");
    fetch(url)
      .then((response) => response.text())
      .then((text) => {
        this.innerHTML = text;
        this.classList.remove("loading");

        setTimeout(() => {
          const title = this.querySelector(
            ".pdp-custom-recommendations__header-title"
          );
          const titleAttr = this.getAttribute("data-title");
          if (title && titleAttr) {
            title.innerText = titleAttr;
          }

          const wrapper = this.querySelector(
            ".pdp-custom-recommendations__wrapper"
          );
          if (wrapper) {
            wrapper.addEventListener(
              "touchstart",
              this.onTouchStart.bind(this)
            );
            wrapper.addEventListener(
              "touchend",
              this.onTouchEnd.bind(this),
              false
            );
          }

          const buttons = this.querySelectorAll(
            ".pdp-custom-recommendations__header-button"
          );
          if (buttons) {
            buttons.forEach((button) => {
              button.addEventListener(
                "click",
                this.onNavigateButtonClick.bind(this)
              );
            });
          }
        }, 100);
      })
      .catch((e) => {
        console.error(e);
      });
  }

  handleGesture() {
    if (Math.abs(this.touchendX - this.touchstartX) > 50) {
      if (this.touchendX < this.touchstartX) {
        this.navigate(true);
      } else if (this.touchendX > this.touchstartX) {
        this.navigate(false);
      }
    }
  }

  onTouchStart(event) {
    this.touchstartX = event.changedTouches[0].screenX;
    this.touchstartY = event.changedTouches[0].screenY;
  }

  onTouchEnd(event) {
    this.touchendX = event.changedTouches[0].screenX;
    this.touchendY = event.changedTouches[0].screenY;
    this.handleGesture();
  }

  onNavigateButtonClick(e) {
    const next = e.target.classList.contains(
      "pdp-custom-recommendations__header-next"
    );
    console.log("e", e);

    this.navigate(next);
  }

  navigate(next) {
    if (this.navigating) {
      return;
    }

    const items = this.getItems();
    const activeIndex = this.getActiveIndex();

    if (next && activeIndex < items.length - 1) {
      items[activeIndex].classList.remove("active");
      items[activeIndex + 1].classList.add("active");
    } else if (!next && activeIndex > 0) {
      items[activeIndex].classList.remove("active");
      items[activeIndex - 1].classList.add("active");
    }

    this.navigating = true;
    setTimeout(() => {
      this.navigating = false;
    }, 450);
  }

  getItems() {
    return this.querySelectorAll(".pdp-custom-recommendations__item");
  }

  getActiveIndex() {
    let index = 0;
    this.getItems().forEach((item, i) => {
      if (item.classList.contains("active")) {
        index = i;
      }
    });
    return index;
  }
};

if (!window.customElements.get("custom-product-recommendations")) {
  window.customElements.define(
    "custom-product-recommendations",
    CustomProductRecommendations
  );
}

function wrapPriceAndReviews() {
  const reviewsBlock = document.querySelector("reviewsio-product-ratings");
  const priceBlock = document.querySelector(
    ".product-info__price .rating-with-text"
  );

  if (reviewsBlock && priceBlock) {
    // Entferne ggf. alten Wrapper, um Dopplungen zu vermeiden
    let oldWrapper = document.querySelector(".price-and-reviews");
    if (oldWrapper) {
      // Entpacke die Elemente, bevor du den Wrapper entfernst
      oldWrapper.parentNode.insertBefore(priceBlock, oldWrapper);
      oldWrapper.remove();
    }

    const wrapper = document.createElement("div");
    wrapper.className = "price-and-reviews";
    priceBlock.parentNode.insertBefore(wrapper, priceBlock);
    wrapper.appendChild(priceBlock);
    wrapper.appendChild(reviewsBlock);
  }
}

document.addEventListener("DOMContentLoaded", wrapPriceAndReviews);

async function saveAndReattachReviewWidget() {
  // Direkt das Reviews-Element sichern (solange es noch da ist)
  const reviewsBlock = document.querySelector("reviewsio-product-ratings");
  if (!reviewsBlock) {
    console.warn("Kein Review-Widget gefunden");
    return;
  }
  // Element sichern und aus dem DOM entfernen, damit es nicht überschrieben wird.
  const savedReviews = reviewsBlock;
  savedReviews.parentNode.removeChild(savedReviews);

  // Warte einige Millisekunden, bis der Preis-Block neu gerendert wurde.
  await new Promise((resolve) => setTimeout(resolve, 100)); // 100ms Delay, ggf. anpassen

  // Jetzt sollte der neue Preis-Block vorhanden sein.
  const priceBlock = document.querySelector(
    ".product-info__price .rating-with-text"
  );
  if (!priceBlock) {
    console.warn("Kein Price-Block gefunden");
    return;
  }

  // Prüfe, ob bereits ein Wrapper existiert, andernfalls erstelle einen neuen.
  let wrapper = document.querySelector(".price-and-reviews");
  if (!wrapper) {
    wrapper = document.createElement("div");
    wrapper.className = "price-and-reviews";
    // Füge den Wrapper vor dem Price-Block ein und verschiebe den Price-Block hinein.
    priceBlock.parentNode.insertBefore(wrapper, priceBlock);
    wrapper.appendChild(priceBlock);
  }

  // Jetzt hänge das gespeicherte Reviews-Widget in den Wrapper ein.
  wrapper.appendChild(savedReviews);
}

document.addEventListener("reviews:rerender", saveAndReattachReviewWidget);

document.addEventListener("DOMContentLoaded", function () {
  // Hier prüfen wir, ob die URL nicht den Editor-Pfad enthält.
  if (
    !window.location.href.includes(
      "admin.shopify.com/store/fissler-shop/themes/1"
    )
  ) {
    var labels = document.querySelectorAll(".section-id-label");
    labels.forEach(function (label) {
      label.remove();
    });
  }
});

document.addEventListener("DOMContentLoaded", function () {
  setTimeout(() => {
    const dataLayerLength = window.dataLayer.length;
    setInterval(() => {
      if (window.dataLayer.length > dataLayerLength) {
        const consentChanges = window.dataLayer.filter(
          (item) => item[0] === "consent" && item[1] === "update"
        );
        if (consentChanges.length < 2) return;
        let consent = consentChanges[0][2];
        if (consentChanges.length > 2) {
          consent = consentChanges[consentChanges.length - 2][2];
        }

        const updatedConsent = consentChanges[consentChanges.length - 1][2];
        let anyRetract = false;
        Object.keys(consent).forEach((key) => {
          if (updatedConsent[key] !== "granted" && consent[key] === "granted") {
            anyRetract = true;
          }
        });
        if (anyRetract) {
          setTimeout(() => {
            window.location.reload();
          }, 100);
        }
      }
    }, 500);
  }, 3000);
});

/* ------------------------------------------------
   BMSM (Buy More Save More) progress bar preservation.
   The theme's product-rerender replaces the payment-terms block,
   destroying the BMSM content injected by the Boomgate app.
   We save it before rerender and restore it after.
------------------------------------------------- */
(function () {
  document.addEventListener(
    "product:rerender",
    function () {
      var bmsm = document.getElementById("bmsm-productPageBlock");
      if (!bmsm) return;
      window.__bmsmSaved = bmsm;
      bmsm.remove();
      setTimeout(function () {
        if (!window.__bmsmSaved) return;
        var target = document.querySelector("[data-block-type='payment-terms'] payment-terms form");
        if (target && !document.getElementById("bmsm-productPageBlock")) {
          target.prepend(window.__bmsmSaved);
        }
        window.__bmsmSaved = null;
      }, 0);
    },
    true
  );
})();

/* ------------------------------------------------
   Klaviyo BIS (Back-In-Stock) button visibility
   on variant change.
   Uses a CSS class on <body> instead of manipulating
   the Klaviyo container directly, so Klaviyo's own
   DOM management is never disrupted.
   - Hide when variant is discontinued (Auslauf/Expired)
   - Show otherwise (Klaviyo handles available vs OOS)
------------------------------------------------- */
(function () {
  function updateKlaviyoBisVisibility(variant) {
    const variantId = variant?.id;
    const metafields = window.productVariantMetafields?.[variantId];
    const isAvailable =
      metafields?.available ?? variant?.available ?? true;
    const productStat = metafields?.ATTR_Product_Stat?.value || "";
    const isDiscontinued =
      productStat === "Auslauf" || productStat === "Expired";

    if (!isAvailable && isDiscontinued) {
      // Discontinued → hide Klaviyo BIS button via body class
      document.body.classList.add("klaviyo-bis-hidden");
    } else {
      // Available or out-of-stock (not discontinued) → let Klaviyo manage visibility
      document.body.classList.remove("klaviyo-bis-hidden");
    }
  }

  // Listen for variant:change on all product forms
  document.addEventListener("variant:change", function (event) {
    updateKlaviyoBisVisibility(event.detail.variant);
  });
})();

/* Reviews are now rendered server-side from product.metafields.trusted_shops.reviews
   by sections/trusted-shops-reviews.liquid. The legacy eTrusted-widget visibility
   manager that lived here grabbed the next sibling of the "Bewertungen" rich-text
   section and hid it after 10 s when it could not detect <etrusted-widget> shadow
   DOM. With the new SSR section this caused visible reviews to disappear after
   the timeout. Reviews are first-party data; no consent gate, no widget-load wait,
   no JS visibility manager required. */

/* A11y: Allow Enter key to toggle checkboxes/radios (screen reader support) */
document.addEventListener("keydown", function (e) {
  if (e.key !== "Enter") return;
  if (e.target.matches('input[type="checkbox"]')) {
    e.preventDefault();
    e.target.checked = !e.target.checked;
    e.target.dispatchEvent(new Event("change", { bubbles: true }));
  } else if (e.target.matches('input[type="radio"]') && !e.target.checked) {
    e.preventDefault();
    e.target.checked = true;
    e.target.dispatchEvent(new Event("change", { bubbles: true }));
  }
});

document.addEventListener("DOMContentLoaded", function () {
  // Prüfen ob wir auf der Cart-Seite sind
  if (window.location.pathname === "/cart") {
    const style = document.createElement("style");
    style.innerHTML = `
      .bmsm-cart-drawer-block {
        display: none !important;
      }
    `;
    document.head.appendChild(style);
  }
});

document.addEventListener("DOMContentLoaded", function () {
  const announcementBar = document.querySelector(".bmsm-stickyannouncementbar");

  if (
    window.location.pathname.includes("/pages/store-locator") ||
    window.location.pathname.includes("/pages/stores/")
  ) {
    const style = document.createElement("style");
    style.innerHTML = `
    .bmsm-stickyannouncementbar {
      display: none !important;
    }
  `;
    document.head.appendChild(style);
  }
  // Ansonsten normale Funktionalität
  else if (announcementBar) {
    const style = document.createElement("style");
    style.innerHTML = `
      .facets__floating-filter {
        transform: translateY(-60px) !important;
      }
    `;
    document.head.appendChild(style);
  }
});

/* ------------------------------------------------
   Keyboard accessibility: ensure wishlist buttons
   (Swish/Wishlist King) are reachable via Tab
------------------------------------------------- */
(function () {
  function fixWishlistButtons() {
    // Target .wk-button by class (newer Wishlist King SDK renders
    // <div class="wk-button"> inside <wishlist-button-*> wrappers)
    document.querySelectorAll(".wk-button").forEach(function (el) {
      if (el.tagName === "BUTTON" || el.tagName === "A") return;
      if (!el.hasAttribute("tabindex")) {
        el.setAttribute("tabindex", "0");
      }
      if (!el.hasAttribute("role")) {
        el.setAttribute("role", "button");
      }
      // Allow keyboard activation with Enter and Space
      if (!el._wkKeyHandler) {
        el._wkKeyHandler = true;
        el.addEventListener("keydown", function (e) {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            el.click();
          }
        });
      }
    });

    // Also handle <wk-button> custom element tag (older SDK)
    document.querySelectorAll("wk-button").forEach(function (wkBtn) {
      var btn = wkBtn.querySelector("button");
      if (btn && btn.tabIndex < 0) {
        btn.tabIndex = 0;
      }
      if (!btn && wkBtn.shadowRoot) {
        btn = wkBtn.shadowRoot.querySelector("button");
        if (btn && btn.tabIndex < 0) {
          btn.tabIndex = 0;
        }
      }
    });
  }

  // Run once when DOM is ready
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", fixWishlistButtons);
  } else {
    fixWishlistButtons();
  }

  // Re-run when new wishlist buttons are injected dynamically
  var observer = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      if (mutations[i].addedNodes.length) {
        fixWishlistButtons();
        break;
      }
    }
  });
  observer.observe(document.body || document.documentElement, {
    childList: true,
    subtree: true,
  });
})();

/* ==========================================================================
   KI-BILD-OVERLAY  (EU-KI-VO Art. 50 / VO (EU) 2024/1689)
   --------------------------------------------------------------------------
   Legt ueber registrierte KI-generierte Bilder ein responsives Hinweis-Overlay.
   Registry kommt aus <script id="ai-overlay-registry"> (snippets/ai-overlay-
   registry.liquid, gespeist aus den `ki_bild`-Metaobjekten). Gematcht wird der
   Original-Dateiname (letztes Pfadsegment vor '?') -> greift an ALLEN
   Ausspielstellen, auch bei JS-nachgeladenen Bildern (Product-Rerender,
   Predictive Search, Recommendations). Nichts wird ins Bild eingebrannt; das
   Overlay skaliert per ResizeObserver mit der gerenderten Ausschnittsgroesse.
   ========================================================================== */
(function () {
  var registryEl = document.getElementById("ai-overlay-registry");
  if (!registryEl) return;

  // Shopify haengt bei Namenskollisionen ein UUID-Suffix an den Dateinamen
  // (z. B. "Header_1_a4e14849-7b13-....png"). Artikel-Headerbilder sind
  // eigene Uploads unter /cdn/shop/articles/ und heissen daher fast immer
  // anders als die in "Inhalte > Dateien" referenzierte Kopie. Matching
  // deshalb zweistufig: erst exakt, dann mit abgestreiftem UUID-Suffix
  // auf BEIDEN Seiten.
  var UUID_SUFFIX =
    /_[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}(?=\.[a-z0-9]+$)/i;
  function normalizeName(name) {
    return name.replace(UUID_SUFFIX, "");
  }

  var aiFiles = new Set();
  var aiFilesNormalized = new Set();
  var registryEntries = [];
  try {
    registryEntries = JSON.parse(registryEl.textContent || "[]");
    registryEntries.forEach(function (item) {
      if (item && item.file) {
        var name = decodeName(item.file);
        aiFiles.add(name);
        aiFilesNormalized.add(normalizeName(name));
      }
    });
  } catch (e) {
    return;
  }
  if (aiFiles.size === 0) return;

  // Registry serialisiert max. 250 Eintraege (Liquid paginate-Limit) -
  // wenn es mehr gibt, fehlt fuer den Rest das Label: laut warnen.
  var registryTotal = parseInt(registryEl.getAttribute("data-total"), 10) || 0;
  if (registryTotal > registryEntries.length && window.console && console.warn) {
    console.warn(
      "[ai-overlay] Registry unvollstaendig: " + registryEntries.length + "/" +
        registryTotal + " KI-Bilder serialisiert (Liquid-paginate-Limit 250)."
    );
  }

  var LABEL = registryEl.getAttribute("data-label") || "KI-generiert";
  var COMPACT_MAX = 130; // px Ausschnittsbreite -> darunter nur Icon (Text sr-only)
  var ICON =
    '<svg class="ai-overlay-badge__icon" viewBox="0 0 24 24" aria-hidden="true" focusable="false">' +
    '<path fill="currentColor" d="M12 1.5l2.35 6.65L21 10.5l-6.65 2.35L12 19.5l-2.35-6.65L3 10.5l6.65-2.35L12 1.5z"/>' +
    '<path fill="currentColor" d="M19 13.5l.9 2.85L22.75 17.25l-2.85.9L19 21l-.9-2.85L15.25 17.25l2.85-.9L19 13.5z"/>' +
    "</svg>";

  function decodeName(s) {
    try {
      return decodeURIComponent(s);
    } catch (e) {
      return s;
    }
  }

  function fileNameFromUrl(url) {
    if (!url) return "";
    var clean = ("" + url).split("?")[0];
    return decodeName(clean.substring(clean.lastIndexOf("/") + 1));
  }

  function isAiImage(img) {
    var src =
      img.currentSrc ||
      img.getAttribute("src") ||
      (img.dataset && img.dataset.src) ||
      "";
    var name = fileNameFromUrl(src);
    if (!name) return false;
    return aiFiles.has(name) || aiFilesNormalized.has(normalizeName(name));
  }

  // Koppelt das Badge an das TATSAECHLICH gerenderte Bild-Rechteck statt an die
  // Container-Ecke: Position = Delta zwischen Bild- und Container-Rect. Damit
  // sitzt es auch dann unten rechts am sichtbaren Bild, wenn die Section das
  // Bild per Transform/Reveal animiert oder der Container groesser ist als das
  // Bild (Kochphasen-Teaser-Bug: Badge hing mitten im Bild).
  function sizeBadge(img) {
    var badge = img.__aiBadge;
    var ref = img.__aiRef;
    if (!badge || !ref || badge.__aiOwner !== img) return;
    var ir = img.getBoundingClientRect();
    if (ir.width < 2 || ir.height < 2) return;
    var rr = ref.getBoundingClientRect();
    // Untergrenze 0.9 (~10px Schrift): auf kleinen Kacheln lesbar bleiben
    // (Accessibility-Feedback); Obergrenze 1.2: auf sehr grossen Bildern
    // (Hero/Slideshow) bleibt das Badge dezent. Dazwischen unveraendert.
    var scale = Math.max(0.9, Math.min(1.2, ir.width / 380));
    // Image-Link-Kacheln haben unten einen CTA-Button - dort etwas
    // kompakter (CTA-Ausweich-Logik unten verhindert Ueberdeckung).
    if (ref.closest && ref.closest(".image-link-blocks__item")) {
      scale = Math.max(0.75, scale * 0.85);
    }
    badge.style.setProperty("--ai-scale", scale.toFixed(3));
    var inset = Math.max(4, 6 * scale);
    badge.style.right = (rr.right - ir.right + inset).toFixed(1) + "px";
    badge.style.bottom = (rr.bottom - ir.bottom + inset).toFixed(1) + "px";
    if (ir.width < COMPACT_MAX) badge.classList.add("ai-overlay-badge--compact");
    else badge.classList.remove("ai-overlay-badge--compact");

    // CTA-Buttons (Image-Link-Kacheln) nie ueberdecken. Wunsch Content-Team:
    // Badge soll unten rechts UNTERHALB des CTA sitzen - wenn der Streifen
    // unter dem Button zu knapp ist, wird das Badge dafuer passend
    // verkleinert (bis 0.6); nur wenn selbst das nicht reicht, wird es als
    // Fallback ueber den CTA gehoben.
    var cta = ref.querySelector && ref.querySelector(".image-link-blocks__cta-button");
    if (cta) {
      var cr = cta.getBoundingClientRect();
      var bb = badge.getBoundingClientRect();
      if (cr.width > 0 && bb.width > 0) {
        var bRight = ir.right - inset;
        var bLeft = bRight - bb.width;
        var bBottom = ir.bottom - inset;
        var bTop = bBottom - bb.height;
        if (cr.left < bRight && cr.right > bLeft && cr.top < bBottom && cr.bottom > bTop) {
          var strip = ir.bottom - cr.bottom; // Platz unterhalb des CTA
          var baseH = bb.height / scale;
          var fitScale = (strip - 3) / baseH; // 2px Inset + 1px Luft
          if (fitScale >= 0.6) {
            if (fitScale < scale) {
              scale = fitScale;
              badge.style.setProperty("--ai-scale", scale.toFixed(3));
            }
            badge.style.bottom = (rr.bottom - ir.bottom + 2).toFixed(1) + "px";
          } else {
            badge.style.bottom = (rr.bottom - cr.top + inset).toFixed(1) + "px";
          }
        }
      }
    }
  }

  // Alle aktiven Badges nachfuehren (rAF-gedrosselt) - noetig bei
  // Scroll-Animationen (Reveal/Zoom-Sections) und Layout-Shifts.
  var tracked = [];
  var syncPending = false;
  function syncAll() {
    if (syncPending) return;
    syncPending = true;
    var run = function () {
      syncPending = false;
      for (var i = 0; i < tracked.length; i++) sizeBadge(tracked[i]);
    };
    if (window.requestAnimationFrame) window.requestAnimationFrame(run);
    else window.setTimeout(run, 16);
  }

  function buildBadge() {
    var badge = document.createElement("span");
    badge.className = "ai-overlay-badge";
    badge.innerHTML =
      ICON + '<span class="ai-overlay-badge__text">' + LABEL + "</span>";
    // Manche Sections erzwingen Textfarben per ID-Selektor + !important auf
    // ALLE spans (z. B. media-with-text-boxed Dark-Mode: span { color: #000
    // !important }) - dagegen gewinnt nur Inline-Style mit !important.
    // Betrifft Badge UND inneren Text-Span (beide matchen "span"); das
    // SVG-Icon erbt via currentColor vom Badge.
    badge.style.setProperty("color", "#ffffff", "important");
    var badgeText = badge.querySelector(".ai-overlay-badge__text");
    if (badgeText) badgeText.style.setProperty("color", "#ffffff", "important");
    return badge;
  }

  // Positionierungs-Container finden, OHNE das Bild zu wrappen (kein Layout-Eingriff).
  // Klettert nur durch Vorfahren, die das Bild noch exakt umschliessen (gleiche Box),
  // und nimmt den aeussersten davon (i.d.R. der Ratio-/Figure-Wrapper).
  function findRef(img) {
    var r = img.getBoundingClientRect();
    var best = null;
    var el = img.parentNode;
    var hops = 0;
    while (el && el.nodeType === 1 && hops < 4) {
      var er = el.getBoundingClientRect();
      if (
        r.width > 0 &&
        Math.abs(er.width - r.width) <= 3 &&
        Math.abs(er.height - r.height) <= 3 &&
        Math.abs(er.left - r.left) <= 3 &&
        Math.abs(er.top - r.top) <= 3
      ) {
        best = el;
      } else {
        break;
      }
      el = el.parentNode;
      hops++;
    }
    if (best) return best;
    return img.parentNode && img.parentNode.nodeType === 1
      ? img.parentNode
      : null;
  }

  function addOverlay(img) {
    if (img.__aiBadge) return;
    var ref = findRef(img);
    if (!ref) return;

    // Container schon mit Badge versehen? (mehrere AI-Bilder im selben Container)
    var existing = ref.querySelector(":scope > .ai-overlay-badge");
    if (existing) {
      img.__aiBadge = existing;
      img.__aiRef = ref;
      return;
    }
    if (window.getComputedStyle(ref).position === "static") {
      ref.style.position = "relative";
    }
    // Eigener Stacking-Kontext: das Badge stapelt nur INNERHALB des
    // Bild-Containers und kann nie ueber aussenliegende UI geraten
    // (Sticky-Header, Onpage-Navigation, Drawer).
    ref.classList.add("ai-overlay-host");

    var badge = buildBadge();
    badge.__aiOwner = img;
    ref.appendChild(badge);
    img.__aiBadge = badge;
    img.__aiRef = ref;
    tracked.push(img);

    sizeBadge(img);
    if (window.ResizeObserver) {
      var ro = new ResizeObserver(function () {
        sizeBadge(img);
      });
      ro.observe(img);
      img.__aiRO = ro;
    }
  }

  function removeOverlay(img) {
    if (img.__aiRO) {
      try {
        img.__aiRO.disconnect();
      } catch (e) {}
      img.__aiRO = null;
    }
    // Badge nur entfernen, wenn dieses Bild es erzeugt hat.
    if (
      img.__aiBadge &&
      img.__aiBadge.__aiOwner === img &&
      img.__aiBadge.parentNode
    ) {
      img.__aiBadge.parentNode.removeChild(img.__aiBadge);
    }
    if (
      img.__aiRef &&
      !img.__aiRef.querySelector(":scope > .ai-overlay-badge")
    ) {
      img.__aiRef.classList.remove("ai-overlay-host");
    }
    var idx = tracked.indexOf(img);
    if (idx !== -1) tracked.splice(idx, 1);
    img.__aiBadge = null;
    img.__aiRef = null;
  }

  function processImg(img) {
    if (!(img instanceof HTMLImageElement)) return;
    var match = isAiImage(img);
    if (match && !img.__aiBadge) addOverlay(img);
    else if (!match && img.__aiBadge) removeOverlay(img);
  }

  function scan(root) {
    if (root && root.tagName === "IMG") {
      processImg(root);
      return;
    }
    var scope = root && root.querySelectorAll ? root : document;
    var imgs = scope.querySelectorAll("img");
    for (var i = 0; i < imgs.length; i++) processImg(imgs[i]);
  }

  var rafPending = false;
  function scheduleFullScan() {
    if (rafPending) return;
    rafPending = true;
    var run = function () {
      rafPending = false;
      scan(document);
    };
    if (window.requestAnimationFrame) window.requestAnimationFrame(run);
    else window.setTimeout(run, 16);
  }

  function init() {
    scan(document);

    var mo = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var m = mutations[i];
        if (m.type === "attributes") {
          if (m.target && m.target.tagName === "IMG") processImg(m.target);
        } else if (m.addedNodes) {
          for (var j = 0; j < m.addedNodes.length; j++) {
            if (m.addedNodes[j].nodeType === 1) scan(m.addedNodes[j]);
          }
        }
      }
    });
    mo.observe(document.body || document.documentElement, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ["src", "srcset"],
    });

    // Async Re-Render-Events des Themes (Bilder tauschen/nachladen)
    ["product:rerender", "variant:change", "reviews:rerender"].forEach(function (
      ev
    ) {
      document.addEventListener(ev, scheduleFullScan);
    });
    // src wird teils erst nach dem Laden final gesetzt
    window.addEventListener("load", scheduleFullScan);

    // Badges an Scroll-Animationen/Layout-Shifts nachfuehren
    // (capture faengt auch innere Scroll-Container wie Slider)
    window.addEventListener("scroll", syncAll, { passive: true, capture: true });
    window.addEventListener("resize", syncAll);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
